import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { Component } from '@theme/component';

/** @typedef {import('./types.js').ProductVariant} ProductVariant */

class ProductPrice extends Component {
  connectedCallback() {
    super.connectedCallback();

    const target = this.closest('.shopify-section, dialog, product-card');
    target?.addEventListener(ThemeEvents.variantUpdate, this.updatePrice);
  }

  disconnectedCallback() {
    super.disconnectedCallback();

    const target = this.closest('.shopify-section, dialog, product-card');
    target?.removeEventListener(ThemeEvents.variantUpdate, this.updatePrice);
  }

  /**
   * @param {Event} event
   */
  updatePrice = (event) => {
    if (!(event instanceof VariantUpdateEvent)) return;
    const variant = /** @type {ProductVariant | null} */ (event.detail?.resource);
    if (!variant) return;

    if (event.detail?.data?.productId && this.dataset.productId && event.detail.data.productId !== this.dataset.productId) {
      return;
    }

    const priceElement = this.querySelector('[data-price]');
    const compareElement = this.querySelector('[data-compare-price]');

    if (priceElement instanceof HTMLElement) {
      priceElement.textContent = variant.price_formatted || priceElement.textContent;
    }

    if (compareElement instanceof HTMLElement) {
      if (
        typeof variant.compare_at_price === 'number' &&
        typeof variant.price === 'number' &&
        variant.compare_at_price > variant.price &&
        variant.compare_at_price_formatted
      ) {
        compareElement.textContent = variant.compare_at_price_formatted;
        compareElement.hidden = false;
      } else {
        compareElement.hidden = true;
      }
    }

    const discountElement = this.querySelector('[data-discount-percentage]');
    if (discountElement instanceof HTMLElement) {
      if (
        typeof variant.compare_at_price === 'number' &&
        typeof variant.price === 'number' &&
        variant.compare_at_price > variant.price
      ) {
        const discount = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
        discountElement.textContent = `-${discount}%`;
        discountElement.hidden = false;
      } else {
        discountElement.hidden = true;
      }
    }
  };
}

if (!customElements.get('product-price')) {
  customElements.define('product-price', ProductPrice);
}
